import React, { useEffect, useState } from "react";
import { getEvents } from "../Service/Api"; 
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
const Events = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const monthNames = [
      "Jan","Feb","Mar", "Apr", "May", "Jun", "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    useEffect(() => {
      const fetchData = async () => {
        try {
          const eventData = await getEvents();
          const validEvents = eventData.filter(
            (item) => typeof item.title === "string" && item.title.trim().length > 0
          );
          const sortedEvents = [...validEvents].sort(
            (a, b) => new Date(b.date) - new Date(a.date)
          );
          const only4enty = sortedEvents.slice(0, 4);
          setData(only4enty);
        } catch (error) {
          setError(error);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }, []);
  return (
    <>
       <div className="eventsec">
       <div class="border-blk">
               <h3>Upcoming Events <Link to="/upcoming-events"><i class="bi bi-chevron-double-right"></i></Link></h3> 
           <div className="row">
           {data && data.length > 0
            ? data.map((item, index) => {
                const date = new Date(item.date);
                const mon = monthNames[date.getMonth()];
                const eventdate = date.getDate(); 
                return (
                    <div className="col-lg-6 col-md-6">
                    <div className="row">
                        <div className="col-xl-7 col-lg-6 col-md-6">
                        <LazyLoad>{item.images.length > 0 ? (  <a data-magnify="gallery" data-src={`https://webapi.entab.info/api/image/${item.images}`}  data-group="a" href={`https://webapi.entab.info/api/image/${item.images}`}>
                        <img src={`https://webapi.entab.info/api/image/${item.images}`} alt="Gallery" className="img-fluid eventimg"/>
                       </a>) : (<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/events.jpg" className="img-fluid eventimg" alt="SPCSH" />) } </LazyLoad>
                            
                        </div>
                        <div className="col-xl-5 col-lg-6 col-md-6">
                            <div className="eventdesc">
                             <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/calicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> {eventdate} {mon}</p>
                             <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/timeicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad>  {item.time}</p>
                             <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/locicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad>  {item.venue}</p>
                             </div>
                        </div>
                        <h5>{item.title}</h5>
                    </div>
               </div> 

                )}):(<>
                    <div className="col-lg-6 col-md-6">
                    <div className="row">
                        <div className="col-xl-7 col-lg-6 col-md-6">
                             <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/event1.jpg" className="img-fluid eventimg" alt="SPCSH" /></LazyLoad>
                             <h5>Vaisakhi</h5>
                        </div>
                        <div className="col-xl-5 col-lg-6 col-md-6">
                            <div className="eventdesc">
                             <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/calicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> 13 April</p>
                             <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/timeicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> 8:00 am</p>
                             <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/locicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> School Campus</p>
                             </div>
                        </div>
                    </div>
               </div>
               <div className="col-lg-6 col-md-6">
                     <div className="row">
                         <div className="col-xl-7 col-lg-6 col-md-6">
                             <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/event2.jpg" className="img-fluid eventimg" alt="SPCSH" /></LazyLoad>
                             <h5>Good Friday</h5>
                         </div>
                         <div className="col-xl-5 col-lg-6 col-md-6">
                             <div className="eventdesc">
                             <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/calicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> 18 April</p>
                             <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/timeicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> 8:00 am</p>
                             <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/locicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> School Campus</p>
                         </div>
                         </div>
                     </div>
          </div>
            
            <div className="col-lg-6 col-md-6">
                 <div className="row">
                     <div className="col-xl-7 col-lg-6 col-md-6">
                          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/event3.jpg" className="img-fluid eventimg" alt="SPCSH" /></LazyLoad>
                          <h5>Bahag bihu/ Vaisakhadi</h5>
                     </div>
                     <div className="col-xl-5 col-lg-6 col-md-6">
                         <div className="eventdesc">
                          <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/calicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> 15 April</p>
                          <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/timeicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> 8:00 am</p>
                          <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/locicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> School Campus</p>
                     </div>
                     </div>
                 </div>
            </div>
            <div className="col-lg-6 col-md-6">
                  <div className="row">
                      <div className="col-xl-7 col-lg-6 col-md-6">
                          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/event4.jpg" className="img-fluid eventimg" alt="SPCSH" /></LazyLoad>
                          <h5>Easter day</h5>
                      </div>
                      <div className="col-xl-5 col-lg-6 col-md-6">
                          <div className="eventdesc">
                          <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/calicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> 13 April</p>
                          <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/timeicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> 8:00 am</p>
                          <p><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/locicn.png" className="img-fluid" alt="SPCSH" /></LazyLoad> School Campus</p>
                      </div>
                      </div>
                  </div>
       </div>
                    </>)} 
              
        </div>
        </div>
       </div>
    </>
  )
}

export default Events
